import { render, staticRenderFns } from "./SchoolLabel.vue?vue&type=template&id=6b29169b&scoped=true&"
import script from "./SchoolLabel.vue?vue&type=script&lang=js&"
export * from "./SchoolLabel.vue?vue&type=script&lang=js&"
import style0 from "./SchoolLabel.vue?vue&type=style&index=0&id=6b29169b&scoped=true&lang=css&"
import style1 from "./SchoolLabel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b29169b",
  null
  
)

export default component.exports